<ng-container *ngIf="quantity">
  <button class="btn cart-btn btn-slim d-flex justify-content-center align-items-center"
          *ngIf="!quantityOnly"
          [class.cart-big]="isBig"
          [class.btn-pink]="isOverview"
          [id]="'cart-button-toggler'"
          (click)="onClick($event)">
    <div class="cart-quantity cart-quantity-border"
         [class.cart-quantity-mobile]="isMobile || isBig">
      <i class="icon-cart me-2"></i>
      <span>{{quantity}}</span>
    </div>

    <span class="{{isMobile || isBig ? 'd-none d-sm-inline' : ''}}">
      {{ 'orderProcess.cakesOverview.cartBtn.viewOrder' | translate }}
    </span>
    <span class="view-order-short"
          [class.d-none]="!isMobile && !isBig">
      {{ 'orderProcess.cakesOverview.cartBtn.viewOrderShort' | translate }}
    </span>
  </button>

  <button class="btn cart-btn btn-slim"
          *ngIf="quantityOnly"
          [class.btn-pink]="isOverview"
          [id]="'cart-button-toggler'"
          (click)="onClick($event)">
    <div class="cart-quantity"
         [class.cart-quantity-mobile]="isMobile || isBig">
      <i class="icon-cart me-2"></i>
      <span>{{quantity}}</span>
    </div>
  </button>
</ng-container>
